import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {
  email = '';
  password = '';

  constructor(private authService: AuthService) { }

  onLogin() {
    this.authService.login({ email: this.email, password: this.password })
      .subscribe({
        next: (res) => {
          // Por ejemplo, si el backend responde con { token: 'xyz' }
          this.authService.setToken(res.token);
          // Redirigir a otra parte
        },
        error: (err) => {
          console.log('Error al hacer login', err);
        }
      });
  }
}
